module.exports = __webpack_public_path__ + "img/title+@3x.684775af.png";